const KEY = "dc_lead_email";

export const readLeadEmail = (): string => {
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
};

export const storeLeadEmail = (email: string): void => {
  try {
    localStorage.setItem(KEY, email.trim().toLowerCase());
  } catch {
    /* ignore */
  }
};

export const isValidEmail = (email: string): boolean =>
  email.trim().length <= 255 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());

export const normalizePrompt = (s: string) => s.replace(/\s+/g, " ").trim().toLowerCase();
